module.exports = __webpack_public_path__ + "static/media/bsu_logo_white.f2c52415.svg";